import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=26d8be30&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=26d8be30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d8be30",
  null
  
)

export default component.exports